export const REQUIRED_DOCUMENTS_COUNT_FETCHED = 'REQUIRED_DOCUMENTS_COUNT_FETCHED';
export const QD_EXTERNAL_COMMERCIAL_MODELS_COUNT_FETCHED = 'QD_EXTERNAL_COMMERCIAL_MODELS_COUNT_FETCHED';
export const QD_EXTERNAL_CONSUMER_MODELS_COUNT_FETCHED = 'QD_EXTERNAL_CONSUMER_MODELS_COUNT_FETCHED';
export const CURRENT_APPLICATIONS_COUNT_FETCHED = 'CURRENT_APPLICATIONS_COUNT_FETCHED';
export const IS_QD_ENABLED = 'IS_QD_ENABLED';
